import React from 'react';
import { Section, Container, SectionTitle, SectionSubtitle } from './styles';

interface SectionContainerProps {
  children: React.ReactNode;
  id?: string;
  title?: string;
  subtitle?: string;
  bgColor?: string;
  padding?: string;
}

const SectionContainer: React.FC<SectionContainerProps> = ({
  children,
  id,
  title,
  subtitle,
  bgColor,
  padding,
}) => {
  return (
    <Section id={id} $bgColor={bgColor} $padding={padding}>
      <Container>
        {title && <SectionTitle>{title}</SectionTitle>}
        {subtitle && <SectionSubtitle>{subtitle}</SectionSubtitle>}
        {children}
      </Container>
    </Section>
  );
};

export default SectionContainer;

